{
	"title": "Modification du mot de passe",
	"labels": {
		"company": "Entreprise",
		"password": "Mot de passe",
		"confirmPassword": "Confirmer le mot de passe"
	},
	"fields": {
		"organization": {
			"placeholder": "Entrez l'entreprise",
			"required": "L'entreprise est requise"
		},
		"password": {
			"placeholder": "Entrez votre mot de passe",
			"required": "Le mot de passe est requis",
			"invalid": "Mot de passe invalide"
		},
		"confirmPassword": {
			"placeholder": "Confirmez votre mot de passe",
			"required": "La confirmation du mot de passe est requise",
			"invalid": "La confirmation du mot de passe est invalide"
		},
		"errors": {
			"required": "Le champ est requis",
			"passwordMustBeSame": "Les mots de passe doivent être identiques",
			"tokenRequired": "Le token est requis",
			"organizationRequired": "L'organisation est requise"
		}
	},
	"submit": "Enregistrer le nouveau mot de passe",
	"successModal": {
		"title": "Le nouveau mot de passe a été enregistré avec succès!",
		"subtitle": "Vous pouvez maintenant accéder au Dashboard Zig avec votre nouveau mot de passe.",
		"btnTitle": "Se connecter"
	},
	"passwordRules": {
		"minLength": "Minimum 8 caractères",
		"uppercase": "Au moins 1 lettre majuscule",
		"lowercase": "Au moins 1 lettre minuscule",
		"number": "Au moins 1 chiffre",
		"special": "Au moins 1 caractère spécial (!@#$...)"
	},
	"passwordRuleState": {
		"passed": "respectée",
		"failed": "non respectée"
	},
	"passwordStrength": {
		"weak": "Faible",
		"fair": "Acceptable",
		"strong": "Fort",
		"veryStrong": "Très fort",
		"ariaLabel": "Force du mot de passe : {{level}}"
	},
	"passwordMatch": {
		"mismatch": "Les mots de passe ne correspondent pas"
	}
}
